/*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this === null) {
                throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}
if (!String.fromCodePoint) {
    (function () {
        var defineProperty = (function () {
            // IE 8 only supports `Object.defineProperty` on DOM elements
            try {
                var object = {};
                var $defineProperty = Object.defineProperty;
                var result = $defineProperty(object, object, object) && $defineProperty;
            } catch (error) {
                console.log(error);
            }
            return result;
        }());
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        var fromCodePoint = function () {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) {
                return '';
            }
            var result = '';
            while (++index < length) {
                var codePoint = Number(arguments[index]);
                if (
                    !isFinite(codePoint) ||       // `NaN`, `+Infinity`, or `-Infinity`
                    codePoint < 0 ||              // not a valid Unicode code point
                    codePoint > 0x10FFFF ||       // not a valid Unicode code point
                    floor(codePoint) !== codePoint // not an integer
                ) {
                    throw RangeError('Invalid code point: ' + codePoint);
                }
                if (codePoint <= 0xFFFF) { // BMP code point
                    codeUnits.push(codePoint);
                } else { // Astral code point; split in surrogate halves
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xD800;
                    lowSurrogate = (codePoint % 0x400) + 0xDC00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        if (defineProperty) {
            defineProperty(String, 'fromCodePoint', {
                'value': fromCodePoint,
                'configurable': true,
                'writable': true
            });
        } else {
            String.fromCodePoint = fromCodePoint;
        }
    }());
}
if (!Array.prototype.map) {

    Array.prototype.map = function (callback/*, thisArg*/) {

        var T, A, k;

        if (this === null) {
            throw new TypeError('this is null or not defined');
        }

        // 1. Let O be the result of calling ToObject passing the |this| 
        //    value as the argument.
        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get internal 
        //    method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If IsCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }

        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 1) {
            T = arguments[1];
        }

        // 6. Let A be a new array created as if by the expression new Array(len) 
        //    where Array is the standard built-in constructor with that name and 
        //    len is the value of len.
        A = new Array(len);

        // 7. Let k be 0
        k = 0;

        // 8. Repeat, while k < len
        while (k < len) {

            var kValue, mappedValue;

            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the HasProperty internal 
            //    method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            if (k in O) {

                // i. Let kValue be the result of calling the Get internal 
                //    method of O with argument Pk.
                kValue = O[k];

                // ii. Let mappedValue be the result of calling the Call internal 
                //     method of callback with T as the this value and argument 
                //     list containing kValue, k, and O.
                mappedValue = callback.call(T, kValue, k, O);

                // iii. Call the DefineOwnProperty internal method of A with arguments
                // Pk, Property Descriptor
                // { Value: mappedValue,
                //   Writable: true,
                //   Enumerable: true,
                //   Configurable: true },
                // and false.

                // In browsers that support Object.defineProperty, use the following:
                // Object.defineProperty(A, k, {
                //   value: mappedValue,
                //   writable: true,
                //   enumerable: true,
                //   configurable: true
                // });

                // For best browser support, use the following:
                A[k] = mappedValue;
            }
            // d. Increase k by 1.
            k++;
        }

        // 9. return A
        return A;
    };
}
jQuery.validator.setDefaults({
    highlight: function (element, errorClass, validClass) {
        if (element.type === 'radio') {
            this.findByName(element.name).addClass(errorClass).removeClass(validClass);
        } else {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
        }
    },
    unhighlight: function (element, errorClass, validClass) {
        if (element.type === 'radio') {
            this.findByName(element.name).removeClass(errorClass).addClass(validClass);
        } else {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
        }
    }
});
jQuery.validator.unobtrusive.adapters.add(
    'requiredif', ['other'], function (options) {

        var getModelPrefix = function (fieldName) {
            return fieldName.substr(0, fieldName.lastIndexOf('.') + 1);
        }

        var appendModelPrefix = function (value, prefix) {
            if (value.indexOf('*.') === 0) {
                value = value.replace('*.', prefix);
            }
            return value;
        }

        var prefix = getModelPrefix(options.element.name),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(':input[name="' + fullOtherName + '"]')[0];

        options.rules['requiredif'] = element;
        if (options.message) {
            options.messages['requiredif'] = options.message;
        }
    }
);

jQuery.validator.addMethod('requiredif', function (value, element, params) {
    var otherValue = $(params).val();
    if (otherValue !== null && otherValue !== '') {
        return true;
    }
    return value !== null && value !== '';
}, '');
(function ($) {
    if ($.fn.style) {
        return;
    }

    // Escape regex chars with \
    var escape = function (text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    };

    // For those who need them (< IE 9), add support for CSS functions
    var isStyleFuncSupported = !!CSSStyleDeclaration.prototype.getPropertyValue;
    if (!isStyleFuncSupported) {
        CSSStyleDeclaration.prototype.getPropertyValue = function (a) {
            return this.getAttribute(a);
        };
        CSSStyleDeclaration.prototype.setProperty = function (styleName, value, priority) {
            this.setAttribute(styleName, value);
            priority = typeof priority !== 'undefined' ? priority : '';
            if (priority !== '') {
                // Add priority manually
                var rule = new RegExp(escape(styleName) + '\\s*:\\s*' + escape(value) +
                    '(\\s*;)?', 'gmi');
                this.cssText =
                    this.cssText.replace(rule, styleName + ': ' + value + ' !' + priority + ';');
            }
        };
        CSSStyleDeclaration.prototype.removeProperty = function (a) {
            return this.removeAttribute(a);
        };
        CSSStyleDeclaration.prototype.getPropertyPriority = function (styleName) {
            var rule = new RegExp(escape(styleName) + '\\s*:\\s*[^\\s]*\\s*!important(\\s*;)?',
                'gmi');
            return rule.test(this.cssText) ? 'important' : '';
        }
    }

    // The style function
    $.fn.style = function (styleName, value, priority) {
        // DOM node
        var node = this.get(0);
        // Ensure we have a DOM node
        if (typeof node === 'undefined') {
            return this;
        }
        // CSSStyleDeclaration
        var style = this.get(0).style;
        // Getter/Setter
        if (typeof styleName !== 'undefined') {
            if (typeof value !== 'undefined') {
                // Set style property
                priority = typeof priority !== 'undefined' ? priority : '';
                style.setProperty(styleName, value, priority);
                return this;
            } else {
                // Get style property
                return style.getPropertyValue(styleName);
            }
        } else {
            // Get CSSStyleDeclaration
            return style;
        }
    };
})(jQuery);

(function ($) {

    setTimezoneCookie();

    $.resizeend = function (el, options) {
        var base = this;

        base.$el = $(el);
        base.el = el;

        base.$el.data("resizeend", base);
        base.rtime = new Date(1, 1, 2000, 12, 0, 0);
        base.timeout = false;
        base.delta = 100;

        base.init = function () {
            base.options = $.extend({}, $.resizeend.defaultOptions, options);

            if (base.options.runOnStart) base.options.onDragEnd();

            $(base.el).resize(function () {
                base.rtime = new Date();
                if (base.timeout === false) {
                    base.timeout = true;
                    setTimeout(base.resizeend, base.delta);
                }
            });
        };
        base.resizeend = function () {
            if (new Date() - base.rtime < base.delta) {
                setTimeout(base.resizeend, base.delta);
            } else {
                base.timeout = false;
                base.options.onDragEnd();
            }
        };

        base.init();
    };

    $.resizeend.defaultOptions = {
        onDragEnd: function () { },
        runOnStart: true
    };

    $.fn.resizeend = function (options) {
        return this.each(function () {
            (new $.resizeend(this, options));
        });
    };
    $.fn.disable = function () {
        return this.each(function () {
            if (typeof this.disabled !== "undefined") this.disabled = true;
        });
    }

    $.fn.enable = function () {
        return this.each(function () {
            if (typeof this.disabled !== "undefined") this.disabled = false;
        });
    }
})(jQuery);

$.fn.animateRotate = function (startAngle, endAngle, duration, easing, complete) {
    return this.each(function () {
        var elem = $(this);

        $({ deg: startAngle }).animate({ deg: endAngle }, {
            duration: duration,
            easing: easing,
            step: function (now) {
                elem.css({
                    '-moz-transform': 'rotate(' + now + 'deg)',
                    '-webkit-transform': 'rotate(' + now + 'deg)',
                    '-o-transform': 'rotate(' + now + 'deg)',
                    '-ms-transform': 'rotate(' + now + 'deg)',
                    'transform': 'rotate(' + now + 'deg)'
                });
            },
            complete: complete || $.noop
        });
    });
};
jQuery.fn.rotate = function (degrees) {
    $(this).css({ 'transform': 'rotate(' + degrees + 'deg)' });
    return $(this);
};

var screen_sm = 750; // 767
var chat_scroll_offset = 50 + 2 + 2;// + 82;
var message_list_offset = 50 + 2 + 22; // navbar height + borders
var bottom_padding = 0;
var current_screen_w;
var current_screen_h;
var nameinit = [];
var window_active = false;
var is_mobile_native = false;

nameinit = LoadData("nameinit");
if (typeof (nameinit) === "undefined" || nameinit === null) {
    nameinit = [];
}

$(window).focus(function () {
    window_active = true;
});

$(window).blur(function () {
    window_active = false;
});
(function () {
    var hidden = "hidden";

    // Standards:
    if (hidden in document)
        document.addEventListener("visibilitychange", onchange);
    else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange);
    else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange);
    else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange);
    // IE 9 and lower:
    else if ("onfocusin" in document)
        document.onfocusin = document.onfocusout = onchange;
    // All others:
    else
        window.onpageshow = window.onpagehide
            = window.onfocus = window.onblur = onchange;

    function onchange(evt) {
        var v = "visible", h = "hidden",
            evtMap = {
                focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h
            };

        evt = evt || window.event;
        if (evt.type in evtMap) {
            window_active = evtMap[evt.type] === "visible";
        } else {
            window_active = this[hidden] ? false : true;
        }
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined)
        onchange({ type: document[hidden] ? "blur" : "focus" });
})();




$(document).ready(function () {

    ApplyFormValidationClasses();

    $(".navbar-collapse").collapse({ 'toggle': false });
    $('.navbar-brand').click(function (e) {
        // e.preventDefault();
    });
    $('.convo-list a').click(function (e) {
        $('.convo-list a').removeClass('active');
        $(this).addClass('active');
    });


    $('body').on('click', function (e) {
        $('.navbar-collapse').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.navbar-collapse').has(e.target).length === 0) {
                $(".navbar-collapse").collapse('hide');
            }
        });
    });

    $('.goback').click(function (e) {
        // e.preventDefault();
        //if ($(this).hasClass('tomessages')) {
        //    document.location.href = 'messages.html';
        //} else {
        //    window.history.back();
        //}
    });
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-center",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "500",
        "hideDuration": "1000",
        "timeOut": "7000",
        "extendedTimeOut": "3000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    if (detectMobileDevice()) {
        toastr.options.positionClass = 'toast-bottom-center';
    }

    if (IsMobileNative()) {
        $(".hide-on-mobile-native").addClass("hidden");
    }

    //$('[title]').tooltip({ container: 'body' });
    current_screen_w = $(window).width();
    current_screen_h = $(window).height();
    ResizeWindow();
    ApplyUIDatePickerComponents();

   
});

$(document).ajaxComplete(function () {
    ApplyFormValidationClasses();
});


$(window).resizeend(
    {
        onDragEnd: function () {
            current_screen_w = $(window).width();
            current_screen_h = $(window).height();
            ResizeWindow();
            $(window).trigger("resizedone");
        },
        runOnStart: true
    }
);
function IsMobileNative() {
    is_mobile_native = Cookies.get("IsMobileNative");
    if (typeof (is_mobile_native) === 'undefined' || is_mobile_native === null) {
        return false;
    } else {
        return is_mobile_native;
    }
}
function ResizeWindow() {
    //return true;

    // Since removing the chat title this might no longer be needed:
    // resizeNavBar();

    if (typeof ScrollToBottom === 'function') {
        ScrollToBottom();
    }

}
function stackTrace() {
    var err = new Error();
    return err.stack;
}
function isOnBottom(elem) {
    if (elem.length > 0 && elem[0].scrollHeight - elem.scrollTop() < elem.outerHeight() + 75) {
        return true;
    }
    else {
        return false;
    }
}


function resizeNavBar() {
    var nav_width = $('.navbar-brand').parent().parent().width();
    if ($('.md_screen').is(":visible")) {
        if (nav_width / 2 - 30 > 20) {
            $('.navbar-brand').width(nav_width / 2 - 30);
        } else {
            $('.navbar-brand').width(100);
        }
    } else if ($('.sm_screen').is(":visible")) {
        if (nav_width / 2 - 30 > 20) {
            $('.navbar-brand').width(nav_width / 3 - 30);
        } else {
            $('.navbar-brand').width(100);
        }
    } else {
        if (nav_width - 130 > 20) {
            $('.navbar-brand').width(nav_width - 130);
        } else {
            $('.navbar-brand').width(20);
        }
    }
}
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function getHashVars() {
    var vars = [], hash;
    var currenthash = window.location.hash;
    if (currenthash.indexOf('#') === 0) {
        currenthash = currenthash.slice(1);
    }
    var hashes = currenthash.split('&');
    for (var i = 0; i < hashes.length; i++) {
        if (hashes[i].length > 0) {
            hash = hashes[i].split('=');
            if (hash.length > 1) {
                vars.push({ name: hash[0], value: hash[1] });
            } else {
                vars.push({ name: hash[0], value: null });
            }
        }
    }
    return vars;
}
function getHashVar(name) {
    var hashArray = getHashVars();
    var index = findWithAttr(hashArray, "name", name);
    if (index > -1) {
        return hashArray[index];
    } else {
        return null;
    }
}
function setHashVars(hashArray) {
    var hash = '';
    if (hashArray.length > 0) {
        for (var i = 0; i < hashArray.length; i++) {
            if (i !== 0) {
                hash += "&";
            }
            if (hashArray[i].value !== null) {
                hash += hashArray[i].name + "=" + hashArray[i].value;
            } else {
                hash += hashArray[i].name;
            }
        }
    }
    window.location.hash = hash;
}
function addHashVar(name, value) {
    var hashArray = getHashVars();
    hashArray.push({ name: name, value: value });
    setHashVars(hashArray);
}
function removeHashVar(name) {
    var hashArray = getHashVars();
    var index = findWithAttr(hashArray, "name", name);
    if (index > -1) {
        hashArray.splice(index, 1);
        setHashVars(hashArray);
    }
}
function urlWOQueryString(url) {
    return url.split("?")[0];
}
function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
}
function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');

    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    if (trident > 0) {
        // IE 11 (or newer) => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}
function postIdleRefresh() {
    console.log("postIdleRefresh called.");
    if (typeof postIdleRefreshAjax === 'function') {
        postIdleRefreshAjax();
    } else {
        window.location.reload(false);
    }
}
function detectMobileDevice() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function SaveData(name, obj) {
    if (localStorage) {
        localStorage.setItem(name, JSON.stringify(obj));
    }
    else {
        console.log('Local Storage is not supported on this browser.');
    }
}
function LoadData(name) {
    var data;
    if (localStorage) {
        data = JSON.parse(localStorage.getItem(name));
    }
    else {
        console.log('Local Storage is not supported on this browser.');
    }
    return data;
}

function GetCachedData(name, dafault_data) {
    var data = LoadData(name);
    if (data === null || typeof (data) === "undefined") {
        return dafault_data;
    } else {
        return data;
    }
}
function CacheData(name, obj) {
    SaveData(name, obj);
}

function LoadDataFromCookie(name, dafault_data) {
    var data;
    data = LoadFromCookie(name);
    if (data === null || typeof (data) === "undefined") {
        return dafault_data;
    } else {
        return JSON.parse(data);
    }
}
function SaveDataToCookie(name, obj, secureOnly) {
    SaveToCookie(name, JSON.stringify(obj), secureOnly);
}

function LoadFromCookie(name) {
    var data;
    if (Cookies) {
        return Cookies.get(name);
    }
    else {
        console.log('Cookies are not supported on this browser.');
    }
    return data;
}
function SaveToCookie(name, data, secureOnly) {
    if (typeof (secureOnly) === "undefined" || secureOnly === null) {
        secureOnly = false;
    }
    if (Cookies) {
        Cookies.set(name, data, { secure: true, sameSite: 'strict' });
    }
    else {
        console.log('Cookies are not supported on this browser.');
    }
}
function LoadDataSafe(name, dafault_data) {
    var data;
    if (localStorage) {
        data = JSON.parse(localStorage.getItem(name));
        if (data === null || typeof (data) === "undefined") {
            return dafault_data;
        }
    }
    else {
        console.log('Local Storage is not supported on this browser.');
    }
    return data;
}
function stringToColour(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var j = 0; j < 3; j++) {
        var value = (hash >> (j * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
}
function shadeBlendConvert(p, from, to) {
    if (typeof (p) !== "number" || p < -1 || p > 1 || typeof (from) !== "string" || (from[0] !== 'r' && from[0] !== '#') || (typeof (to) !== "string" && typeof (to) !== "undefined")) return null; //ErrorCheck
    if (!this.sbcRip) this.sbcRip = function (d) {
        var l = d.length, RGB = new Object();
        if (l > 9) {
            d = d.split(",");
            if (d.length < 3 || d.length > 4) return null;//ErrorCheck
            RGB[0] = i(d[0].slice(4)), RGB[1] = i(d[1]), RGB[2] = i(d[2]), RGB[3] = d[3] ? parseFloat(d[3]) : -1;
        } else {
            if (l === 8 || l === 6 || l < 4) return null; //ErrorCheck
            if (l < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? d[4] + "" + d[4] : ""); //3 digit
            d = i(d.slice(1), 16), RGB[0] = d >> 16 & 255, RGB[1] = d >> 8 & 255, RGB[2] = d & 255, RGB[3] = l === 9 || l === 5 ? r(((d >> 24 & 255) / 255) * 10000) / 10000 : -1;
        }
        return RGB;
    }
    h = typeof (to) === "string" ? to.length > 9 ? true : to === "c" ? !h : false : h;
    to = to && to !== "c" ? to : b ? "#000000" : "#FFFFFF";
    p = b ? p * -1 : p;
    var i = parseInt, r = Math.round, h = from.length > 9,
        b = p < 0,
        f = sbcRip(from), t = sbcRip(to);

    if (!f || !t) return null; //ErrorCheck
    if (h) return "rgb(" + r((t[0] - f[0]) * p + f[0]) + "," + r((t[1] - f[1]) * p + f[1]) + "," + r((t[2] - f[2]) * p + f[2]) + (f[3] < 0 && t[3] < 0 ? ")" : "," + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000 : t[3] < 0 ? f[3] : t[3]) + ")");
    else return "#" + (0x100000000 + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 255) : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255) * 0x1000000 + r((t[0] - f[0]) * p + f[0]) * 0x10000 + r((t[1] - f[1]) * p + f[1]) * 0x100 + r((t[2] - f[2]) * p + f[2])).toString(16).slice(f[3] > -1 || t[3] > -1 ? 1 : 3);
}
function setTimezoneCookie() {

    var timezone_cookie = "timezoneoffset";

    // if the timezone cookie not exists create one.
    if (!Cookies.get(timezone_cookie)) {

        // check if the browser supports cookie
        var test_cookie = 'test_cookie';
        SaveToCookie(test_cookie, true, false);

        // browser supports cookie
        if (Cookies.get(test_cookie)) {

            // delete the test cookie
            SaveToCookie(test_cookie, null, false);

            // create a new cookie 
            SaveToCookie(timezone_cookie, new Date().getTimezoneOffset(), false);

            // re-load the page
            location.reload();
        }
    }
    // if the current timezone and the one stored in cookie are different
    // then store the new timezone in the cookie and refresh the page.
    else {

        var storedOffset = parseInt(Cookies.get(timezone_cookie));
        var currentOffset = new Date().getTimezoneOffset();

        // user may have changed the timezone
        if (storedOffset !== currentOffset) {
            SaveToCookie(timezone_cookie, new Date().getTimezoneOffset(), false);
            location.reload();
        }
    }
}
function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}
function findWithDualAttr(array, attr1, value1, attr2, value2) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr1] === value1 && array[i][attr2] === value2) {
            return i;
        }
    }
    return -1;
}
function LocalDate(date) {
    date = new Date(date);
    return date.toString().replace('/','-');
}
function arrayMerge(array1, array2, compare) {
    var result = array1.filter(compare);
    result = [].concat(result, array2);
    return result;
}
function RelativeDate(dateo) {
    var date = new Date(dateo);
    var now = new Date();
    var yesterday = new Date();
    yesterday.setHours(0, 0, 0, 0);
    var hourago = new Date();
    hourago.setHours(hourago.getHours() - 1)
    var result = "";
    if (date < yesterday) {
        result = (date.getMonth() + 1) + "-" + date.getDate() + "-" + date.getFullYear();// date.AddMinutes(-1*clientTZoffset).ToString("M-dd-yyyy");
    }
    else if (date > yesterday && date < hourago) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        result = hours + ':' + minutes + ' ' + ampm;
        // result = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();// date.AddMinutes(-1 * clientTZoffset).ToString("h:mm:ss tt");
    }
    else {
        var diff = Math.abs(now - date);
        var diffminutes = Math.floor(diff / 60000);
        if (diffminutes === 1) {
            result = diffminutes + " min";
        }
        else if (diffminutes > 1) {
            result = diffminutes + " mins";
        }
        else {
            result = "Just now";
        }
    }
    return result;
}
function ApplyUIDatePickerComponents() {
    var DateFormat = 'MM/DD/YYYY';
    $('.datepicker').datetimepicker({
        format: DateFormat,
    });
    $('.timepicker').datetimepicker({
        format: 'hh:mm A',
        //pick12HourFormat: false,   // enables the 12-hour format time picker
        //pickSeconds: true
    });
    $('.datetimepicker').datetimepicker({
        format: DateFormat + ' hh:mm A',
        //pick12HourFormat: false,   // enables the 12-hour format time picker
        //pickSeconds: true
    });
    $('.datetimepickertoggle').datetimepicker({
        format: DateFormat + ' hh:mm A',
        allowInputToggle: true
        //pick12HourFormat: false,   // enables the 12-hour format time picker
        //pickSeconds: true
    });
    $('.bdatepicker').datetimepicker({  // this is now used in the ExtentionHelper.cs
        format: DateFormat,
        maxDate: 'now',
    });
}
function ApplyFormValidationClasses() {
    $("span.field-validation-valid, span.field-validation-error").addClass('help-block');
    $("div.form-group").has("span.field-validation-error").addClass('has-error');
    $("div.validation-summary-errors").has("li:visible").addClass("alert alert-block alert-danger");
}
function addUrlParam(search, key, val) {
    var newParam = key + '=' + val,
        params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
            params += '&' + newParam;
        }
    }
    window.location.hash = params;
    return params;
}
function LoadImagePreview(input, destination_selector, height, width, current_image_selector) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
            $(destination_selector).empty();
            var content = $('<div>').addClass('content');
            if (mimetypes.indexOf(input.files[0].type) > -1) {
                var preview = $('<p>');
                preview.text('Uploaded Image Preview');
                preview.appendTo(content);
                var img = $('<img id="img_preview">');
                img.attr('src', e.target.result);
                img.css('max-height', height);
                img.css('max-width', width);
                img.appendTo(content);
                var cancel = $('<a>').text("Cancel").addClass('btn btn-danger btn-xs');
                cancel.css('margin', '10px');
                cancel.click(function (e) {
                    e.preventDefault();
                    $(destination_selector).empty();
                    $(input).val('');
                    if (typeof (current_image_selector) !== 'undefined' && current_image_selector.length > 0) {
                        $(current_image_selector).show();
                    }
                })
                cancel.appendTo(content);
            }
            else {
                var link = $('<span>');
                link.text(input.files[0].name + " is not a valid image.");
                link.appendTo(content);
            }
            content.appendTo(destination_selector);
            if (typeof (current_image_selector) !== 'undefined' && current_image_selector.length > 0) {
                $(current_image_selector).hide();
            }
        }
        reader.readAsDataURL(input.files[0]);
    }
}
function DismissAlert(dismiss_url, alert_id) {
    ExecuteAjaxGet(dismiss_url + '?alert_id=' + alert_id, "The alert could not be dismissed.", function (data) {
        console.log(data);
    });
}
var alerted_ids = [];
function LoadAlerts(ajaxUrl, dismiss_url) {
    ExecuteAjaxGet(ajaxUrl, "The alerts could not be loaded.", function (data) {
        if (data.Data.length > 0) {
            var alerts = data.Data.reverse();
            for (var i = 0; i < alerts.length; i++) {
                var item = alerts[i];
                var index = alerted_ids.indexOf(item.SystemAlertId)
                if (index === -1) {
                    alerted_ids.push(item.SystemAlertId);
                    var tsettings = { "timeOut": 0, "closeButton": true, "tapToDismiss": false, "onclick": null, "extendedTimeOut": 0, "preventDuplicates": true, "positionClass": "toast-top-full-width", "alert_id": item.SystemAlertId };
                    tsettings.onHidden = function () {
                        DismissAlert(dismiss_url, this.alert_id);
                        var index = alerted_ids.indexOf(this.alert_id)
                        if (index > -1) {
                            alerted_ids.splice(index, 1);
                        }
                    }
                    var tstr = null;
                    switch (item.AlertType) {
                        case 0:
                            tstr = toastr.info(item.Message, null, tsettings);
                            break;
                        case 1:
                            tstr = toastr.success(item.Message, null, tsettings);
                            break;
                        case 2:
                            tstr = toastr.warning(item.Message, null, tsettings);
                            break;
                        case 3:
                            tstr = toastr.error(item.Message, null, tsettings);
                            break;
                        default:
                    }
                }

            }
        }
    });
}
function IsNotNull(obj) {
    return obj !== null;
}
function IsNull(obj) {
    return obj === null;
}
function IsNotEmpty(obj) {
    return IsNotNull(obj) && obj.length > 0;
}
function IsUndefined(obj) {
    return typeof obj === 'undefined';
}
function ExecuteAjaxGet(url, failedMessage, doneFunction, supress_error) {
    $.ajax({
        url: url,
        success: function (data) {
            if (data) {
                if (typeof doneFunction === "function") {
                    doneFunction(data);
                }
            } else {
                if (!supress_error) {
                    toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during background function call.");
                }
            }
        },
        statusCode: {
            404: function () {
                if (!supress_error) {
                    toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during background function call. (404)");
                }
            },
            500: function () {
                if (!supress_error) {
                    toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during a background function call. (500)");
                }
            }
        }
    });
}
function ExecuteAjaxGetPlain(url, doneFunction, failFunction) {
    $.ajax({
        url: url,
        success: function (data, textStatus, request) {
            if (data) {
                if (typeof doneFunction === "function") {
                    doneFunction(data);
                }
            } else {
                failFunction(textStatus,request);
            }
        },
        error: function (request, textStatus, errorThrown) {
            failFunction(textStatus, request, errorThrown);
        }
    });
}
function ExecuteAjaxPost(url, payload, failedMessage, doneFunction, failFunction) {
    $.ajax({
        url: url,
        type: "POST",
        data: payload,
        //data: JSON.stringify(payload),
        //contentType: "application/json; charset=utf-8",
        //dataType: "json",
        success: function (data) {
            if (data) {
                if (typeof doneFunction === "function") {
                    doneFunction(data);
                }
            } else {
                toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during background function call.");
            }
        },
        error: function (request, textStatus, errorThrown) {
            if (typeof failFunction === "function") {
                failFunction(request, textStatus, errorThrown);
            } else {
                if (request.status === 404) {
                    toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during background function call. (404)");
                } else if (request.status === 500) {
                    toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during a background function call. (500)");
                }
            }
        }
        //,
        //statusCode: {
        //    404: function (data, data2, data3, data4) {
        //        toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during background function call. (404)");
        //    },
        //    500: function (data, data2, data3, data4) {
        //        toastr.error(IsNotEmpty(failedMessage) ? failedMessage : "Error occurred during a background function call. (500)");
        //    }
        //}
    });
}

function NavigateToUrl(url) {
    var queryIndicator = "";
    if (url.indexOf("#") > 0) {
        queryIndicator = "#"
    } else if (url.indexOf("&") > 0) {
        queryIndicator = "&"
    }
    var rawOriginal = window.location.toString().toLowerCase();
    var rawUrl = url.toString().toLowerCase();
    window.location.href = url;
    if (queryIndicator !== "") {
        if (rawOriginal.indexOf(queryIndicator) >= 0) {
            rawOriginal = rawOriginal.slice(0, rawOriginal.indexOf(queryIndicator));
        }
        if (rawUrl.indexOf(queryIndicator) >= 0) {
            rawUrl = rawUrl.slice(0, rawUrl.indexOf(queryIndicator))
        }
        if (rawOriginal === rawUrl) {
            window.location.reload();
        }
    }


    console.log("Clicked to navigate to: " + url);
}
